
import searchBar from '@/components/SearchBar';
import list from './component/list';
import { getItavMaterialList } from '@/api/res_store/list';

export default {
  components: {
    searchBar: searchBar,
    list: list
  },

  data: function data() {
    return {
      aList: [],
      bListLoading: true,
      nPage: 1,
      nPageSize: 15,
      nTotal: 1,
      oSearchData: {},
      aSearchProp: {
        customSelector: [{
          selectorId: 'tag1_id',
          name: '风格',
          tagId: 3,
          multiple: true
        }, {
          selectorId: 'tag2_id',
          name: '动作',
          tagId: 2,
          multiple: true
        }],
        searchField: true,
        keyword: true,
        defaultKey: 'name',
        aSearchField: [{
          id: 'name',
          name: '按模型名称'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.fnRenderList();
  },


  methods: {
    fnRenderList: function fnRenderList(data) {
      var oTemp = {};
      var self = this;
      if (data) {
        self.oSearchData = data;
        self.nPage = 1;
      }
      oTemp = self.oSearchData;
      oTemp.res_type = 1;
      oTemp.page = self.nPage;
      self.bListLoading = true;
      getItavMaterialList(oTemp).then(function (res) {
        self.bListLoading = false;
        self.aList = res.data.data.list;
        self.nTotal = res.data.data.total;
      });
    },
    fnCurrentChange: function fnCurrentChange(val) {
      this.nPage = val;
      this.fnRenderList();
    }
  }
};